import axios from 'axios';
import tokenService from '../utils/tokenService';

const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// 메인 API 인스턴스 생성
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// 요청 인터셉터
api.interceptors.request.use(
  async (config) => {
    const token = await tokenService.getToken();
    if (token && tokenService.isTokenExpired && tokenService.isTokenExpired()) {
      tokenService.removeToken();
      const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
      const isWorkerPage = pathname === '/dyeing-worker' || pathname.startsWith('/dyeing-worker/');
      if (!isWorkerPage && pathname !== '/') {
        localStorage.setItem('sessionExpired', 'true');
        window.location.href = '/';
      }
      return Promise.reject(new Error('Token expired'));
    }
    if (token) {
      config.headers['x-user-jwt'] = token;
    }

    if (config.url) {
      if (!config.url.startsWith('/') && !config.url.startsWith('http')) {
        config.url = `/${config.url}`;
      }
    }

    if (
      config.url
      && (
        config.url.includes('/mes/dyeing/v1/recipe/list')
        || config.url.includes('/mes/dyeing/v2/recipe/search')
      )
    ) {
      console.log('🚀 레시피 검색 API 요청:', {
        url: config.url,
        method: config.method,
        params: config.params,
        baseURL: config.baseURL,
        fullURL: `${config.baseURL}${config.url}`
      });
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 응답 인터셉터
api.interceptors.response.use(
  (response) => {
    if (
      response.config.url
      && (
        response.config.url.includes('/mes/dyeing/v1/recipe/list')
        || response.config.url.includes('/mes/dyeing/v2/recipe/search')
      )
    ) {
      console.log('✅ 레시피 검색 API 응답 성공:', {
        status: response.status,
        data: response.data,
        url: response.config.url
      });
    }
    return response;
  },
  (error) => {
    if (
      error.config?.url
      && (
        error.config.url.includes('/mes/dyeing/v1/recipe/list')
        || error.config.url.includes('/mes/dyeing/v2/recipe/search')
      )
    ) {
      console.error('❌ 레시피 검색 API 응답 실패:', {
        status: error.response?.status,
        message: error.message,
        data: error.response?.data,
        url: error.config.url
      });
    }

    if (error.response?.status === 401) {
      if (error.config.url !== '/checkin') {
        tokenService.removeToken();

        const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
        const isWorkerPage = pathname === '/dyeing-worker' || pathname.startsWith('/dyeing-worker/');
        if (!isWorkerPage && pathname !== '/') {
          localStorage.setItem('sessionExpired', 'true');
          window.location.href = '/';
        }
      }
    }
    return Promise.reject(error);
  }
);

export const apiClient = {
  get: (url, config) => api.get(url, config),
  post: (url, data, config) => api.post(url, data, config),
  put: (url, data, config) => api.put(url, data, config),
  delete: (url, config) => api.delete(url, config),
  patch: (url, data, config) => api.patch(url, data, config),
  request: (config) => api.request(config)
};

export const API_CONFIG = {
  CLIENT_SECRET,
  BASE_URL
};

export default api;
